import React from "react";
import { createRoot } from "react-dom/client";
import { ApolloProvider } from "@apollo/client";
import { graphqlClient } from "utils/graphqlClient";

import App from "pages/App";

import "styles/index.sass";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <ApolloProvider client={graphqlClient}>
    <App />
  </ApolloProvider>,
);
